import React from 'react';
import PropTypes from 'prop-types';
import { BaasicButton, BaasicFormControls} from "core/components";
import { defaultTemplate } from 'core/hoc';
import { NikoTemplateCreate } from 'application/niko-patient/components';

function NikoTemplateCreateModalTemplate({ nikoCreateTemplateModalStore, t }) {
    const {
        form,
        modalParams,
        nikoPatientDetail,
        nikoTemplateCreateViewStore,
        disabled
    } = nikoCreateTemplateModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Create a new order</h3>
            </div>

            <div className="modal__body">
                <h3 className='type--sml u-mar--bottom--med'>
                    {nikoPatientDetail && nikoPatientDetail.nikoPatient.lastName && ` ${nikoPatientDetail.nikoPatient.lastName}`}
                    {nikoPatientDetail && nikoPatientDetail.nikoPatient.lastName && nikoPatientDetail.nikoPatient.firstName && ', '}
                    {nikoPatientDetail && nikoPatientDetail.nikoPatient.firstName && `${nikoPatientDetail.nikoPatient.firstName}`}
                </h3>

                <NikoTemplateCreate
                    nikoTemplateCreateViewStore={nikoTemplateCreateViewStore}
                    disabled={disabled}
                />
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={form.submitting || form.validating}
                />
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Create"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section >
    )
}

NikoTemplateCreateModalTemplate.propTypes = {
    nikoCreateTemplateModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoTemplateCreateModalTemplate);
